<div class="row justify-content-center">
        <div class="{{brand_class}}">
            <p>{{ 'logos.sponsor' | translate}}</p>
            <img src="assets/templos/amal.png"  alt="" height="100px">
        </div>

    <div class="{{brand_class}}">
        <p>{{ 'logos.support' | translate}}</p>
        <img src="assets/templos/logo-rio.png"  alt="" height="100px">
    </div>

    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/abou.png"  alt="" height="100px">
    </div>
    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/hikmat.png"  alt="" height="100px">
    </div>
    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/salah.png"  alt="" height="100px">
    </div>
    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/bolivia.jpg"  alt="" height="100px">
    </div>
    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/alrei.png"  alt="" height="100px">
    </div>
    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/alalala.png"  alt="" height="100px">
    </div>
    <div class="{{brand_class}}">
        <p>{{ 'logos.affiliate' | translate}}</p>
        <img src="assets/templos/paraguai.jpeg"  alt="" height="100px">
    </div>

</div>
